function formatList(list) {
    if (list.length === 1) {
        return list[0];
    }
    return list.slice(0, -1).join(', ') + ' or ' + list[list.length - 1];
}
function isArray(value) {
    return Array.isArray(value);
}
export function formatTypeForParameter(parameter, plural) {
    const schema = parameter.schema;
    if (!schema) {
        return null;
    }
    return formatTypeForSchema(schema);
}
export function formatTypeForSchema(schema, plural) {
    if (typeof schema === 'boolean' || Object.keys(schema).length === 0) {
        if (schema) {
            return null;
        }
        else {
            return 'undefined';
        }
    }
    const { type, format } = schema;
    if (!type) {
        return null;
    }
    if (isArray(type)) {
        return formatList(type.map((singleType) => {
            return formatTypeForSchema(Object.assign(Object.assign({}, schema), { type: singleType }));
        }));
    }
    if (type === 'string') {
        switch (format) {
            case 'date':
                return plural ? 'dates' : 'date';
            case 'time':
                return plural ? 'times' : 'time';
            case 'date-time':
                return plural ? 'timestamps' : 'timestamp';
            case 'email':
                return plural ? 'emails' : 'email';
            case 'phone':
                return plural ? 'phones' : 'phone';
            case 'uuid':
                return plural ? 'UUIDs' : 'UUID';
        }
        return plural ? 'strings' : 'string';
    }
    if (type === 'array') {
        if (typeof schema.items === 'boolean') {
            if (schema.items === true || Object.keys(schema.items).length === 0) {
                return plural ? 'arrays' : 'array';
            }
            else {
                return plural ? 'empty arrays' : 'empty array'; // TODO: what if there is prefixItems?
            }
        }
        const itemsTypeDescription = schema.items ? formatTypeForSchema(schema.items, true) : null;
        if (itemsTypeDescription) {
            return `${plural ? 'arrays' : 'array'} of ${itemsTypeDescription}`;
        }
    }
    return plural ? pluralType(type) : type;
}
function pluralType(type) {
    switch (type) {
        case 'string':
            return 'strings';
        case 'number':
            return 'numbers';
        case 'boolean':
            return 'booleans';
        case 'object':
            return 'objects';
        case 'null':
            return 'nulls';
        case 'array':
            return 'arrays';
        case 'integer':
            return 'integers';
    }
}
